export const TRANSFERS_PER_PAGE = 20; // Controls how many transfers are on a page
